import { z } from '@/utils/zod'
import { createMultilingualTextSchema } from '@/entities/common'

export const ScopeIconSchema = z.enum([
    'id',
    'user',
    'email',
    'mapPin',
    'phone',
    'clock',
    'calendar',
    'document',
    'database',
    'shield',
    'key',
    'lock',
    'settings',
    'generic',
])

export type ScopeIcon = z.infer<typeof ScopeIconSchema>

export const ScopeDisplaySchema = z.object({
    title: createMultilingualTextSchema(60),
    description: createMultilingualTextSchema(160),
    icon: ScopeIconSchema,
})

export type ScopeDisplay = z.infer<typeof ScopeDisplaySchema>
